import {useState, useEffect} from 'react';
import Chip from '@mui/material/Chip';
import Rating from '@mui/material/Rating';
import { styled } from '@mui/material/styles';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import LensIcon from '@mui/icons-material/Lens';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import { Emoji } from 'emoji-picker-react';
import FileService from '@Helpers/URLHelpers/FileService';
import FileFrame from '@IssueConsoleFunctionalDisplay/FileFrame';
import { useReduxFileStorage } from '@Hooks/reduxFileStorageHook/useReduxFileStorage';
import './FieldView.scss';

export default function FieldView(props) {

    const { currentFiles } = useReduxFileStorage();
    const [, setFieldEntry] = useState([]);
    const [fieldEntryOptions, setFieldEntryOptions] = useState([]);
    const [fileList, setFileList] = useState([]);
    const [fieldEntryValue, setFieldEntryValue] = useState();
    const [, setRules] = useState([]);
    const [, setOptions] = useState([]);
    const [ratingRange, setRatingRange] = useState(5);
    const [ratingType, setRatingType] = useState('');
    const [ratingScaleIcon, setRatingScaleIcon] = useState('star');
    const [ratingInitialLabel, setRatingInitialLabel] = useState('');
    const [ratingFinalLabel, setRatingFinalLabel] = useState('');
    const fileService = new FileService();
    const className = 'ticketView-fieldView';

    const HeartStyledRating = styled(Rating)({
      '& .MuiRating-iconFilled': {
        color: '#ff6d75',
      },
      '& .MuiRating-iconHover': {
        color: '#ff3d47',
      },
    });

    const CircleStyledRating = styled(Rating)({
      '& .MuiRating-iconFilled': {
        color: '#2784B9d6',
      },
      '& .MuiRating-iconHover': {
        color: '#2784B9',
      },
    });

    useEffect(() => {
        renderData();
    }, [props?.fieldEntries, props?.field?.id, props?.field?.type, props?.field?.options, props?.field?.rules, props?.ticket])

    const renderData = async() => {
        let fieldEntryObj = props.fieldEntries?.find((fieldEntry) => fieldEntry.fieldId === props.field.id);
        if(!!fieldEntryObj) {
            setFieldEntry(fieldEntryObj);
            let fieldEntryValueObj = fieldEntryObj.entryValue;
            setFieldEntryValue(fieldEntryValueObj);
        }
        if(!!props.field.options) {
            setFieldEntryOptions(JSON.parse(props.field.options));
        }
        try {
            if(!!props.ticket && Object.keys(props.ticket).length !== 0) {
                let rulesObj = [];
                let optionsObj = [];
                if(!!props.field?.rules) {
                    rulesObj = JSON.parse(props.field?.rules);
                    setRules(rulesObj);
                }
                if(!!props.field?.options) {
                    optionsObj = JSON.parse(props.field?.options);
                    setOptions(optionsObj);
                }
                if(props?.field?.type === 'file') {
                    if(!!currentFiles) {
                        let fileNameList = Object.keys(currentFiles || {});
                        let fileListObj = [];
                        for(var i = 0; i < fileNameList.length; i++) {
                            let fileObj = currentFiles[fileNameList[i]];
                            fileListObj = [...fileListObj, fileObj];
                        }
                        setFileList(fileListObj);
                    }
                }
                if(props.field?.type == 'rating') {
                    setRatingRange(rulesObj.find((rule) => rule.type === 'width')?.value)
                    setRatingType(rulesObj.find((rule) => rule.type === 'ratingType')?.value)
                    setRatingScaleIcon(rulesObj.find((rule) => rule.type === 'scaleIcon')?.value)
                    setRatingFinalLabel(rulesObj.find((rule) => rule.type === 'ratingFinalLabel')?.value)
                    setRatingInitialLabel(rulesObj.find((rule) => rule.type === 'ratingInitialLabel')?.value)
                }
            }
        } catch (err) {
        }
    }

    return (
        <div className={className + ' width-wfa'}>
            <div className={className + '__inner flex-row-center-1rem-gap width-wfa'}>
                {
                    props?.field?.type === 'file' && !!props.ticket && Object.keys(props.ticket).length !== 0 &&
                        <div className={className + '__inner__file flex-row-flex-start-1rem-gap width-wfa'}>
                            <div className={className + '__inner__file__title semi-bold-text'}>
                                {props?.field?.title}
                            </div>
                            <div className={className + '__inner__file__list flex-row-center-1rem-gap'}>
                                {
                                    fileList.map((file) =>
                                        <FileFrame
                                            file={file}
                                            fileType={file?.fileType}
                                            deleteFile={null}/>
                                    )
                                }
                            </div>
                        </div>
                }
                {
                    props?.field?.type === 'date' && !!props.ticket && Object.keys(props.ticket).length !== 0 &&
                        <div className={className + '__inner__date flex-row-flex-start-1rem-gap width-wfa'}>
                            <div className={className + '__inner__date__title semi-bold-text'}>
                                {props?.field?.title}
                            </div>
                            <div className={className + '__inner__number__value'}>
                                {new Intl.DateTimeFormat('en-US', {year: 'numeric', month: 'short',day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit'}).format(fieldEntryValue)}
                            </div>
                        </div>
                }
                {
                    props?.field?.type === 'number' && !!props.ticket && Object.keys(props.ticket).length !== 0 &&
                        <div className={className + '__inner__number flex-row-flex-start-1rem-gap width-wfa'}>
                            <div className={className + '__inner__number__title semi-bold-text'}>
                                {props?.field?.title}
                            </div>
                            <div className={className + '__inner__number__value'}>
                                {fieldEntryValue}
                            </div>
                        </div>
                }
                {
                    props?.field?.type === 'phoneNumber' && !!props.ticket && Object.keys(props.ticket).length !== 0 &&
                        <div className={className + '__inner__number flex-row-flex-start-1rem-gap width-wfa'}>
                            <div className={className + '__inner__number__title semi-bold-text'}>
                                {props?.field?.title}
                            </div>
                            <div className={className + '__inner__number__value'}>
                                {fieldEntryValue}
                            </div>
                        </div>
                }
                {
                    props?.field?.type === 'text' && !!props.ticket && Object.keys(props.ticket).length !== 0 &&
                        <div className={className + '__inner__text flex-row-flex-start-1rem-gap width-wfa'}>
                            <div className={className + '__inner__text__title semi-bold-text'}>
                                {props?.field?.title}
                            </div>
                            <div className={className + '__inner__text__value'}>
                                {fieldEntryValue}
                            </div>
                        </div>
                }
                {
                    props?.field?.type === 'multiChoice' && !!props.ticket && Object.keys(props.ticket).length !== 0 &&
                        <div className={className + '__inner__multiChoice flex-row-flex-start-1rem-gap width-wfa'}>
                            <div className={className + '__inner__multiChoice__title semi-bold-text'}>
                                {props?.field?.title}
                            </div>
                            <div className={className + '__inner__multiChoice__value'}>
                                {
                                    !!fieldEntryOptions?.find((option) => Number(fieldEntryValue) === option.id) &&
                                        <Chip
                                            label={fieldEntryOptions?.find((option) => Number(fieldEntryValue) === option.id).title}
                                            variant='outlined'
                                            color='primary'
                                            size='medium'
                                            avatar={<div className={className + '__top__left__status__indicator small-indicator-box'}
                                                    style={{background: fieldEntryOptions?.find((option) => Number(fieldEntryValue) === option.id).color}}/>}
                                            />
                                }
                            </div>
                        </div>
                }
                {
                    props?.field?.type === 'multiSelect' && !!props.ticket && Object.keys(props.ticket).length !== 0 &&
                        <div className={className + '__inner__multiSelect flex-row-flex-start-1rem-gap width-wfa'}>
                            <div className={className + '__inner__multiSelect__title semi-bold-text'}>
                                {props?.field?.title}
                            </div>
                            <div className={className + '__inner__multiChoice__value flex-row-center-1rem-gap'}>
                                {
                                    !!fieldEntryValue &&
                                        JSON.parse(fieldEntryValue).map((fieldEntry) =>
                                            <Chip
                                                label={fieldEntryOptions?.find((option) => Number(fieldEntry) === option.id).title}
                                                variant='outlined'
                                                color='primary'
                                                size='medium'
                                                avatar={<div className={className + '__top__left__status__indicator small-indicator-box'}
                                                        style={{background: fieldEntryOptions?.find((option) => Number(fieldEntry) === option.id).color}}/>}
                                                />
                                        )
                                }
                            </div>
                        </div>
                }
                {
                    props?.field?.type === 'rating' && !!props.ticket && Object.keys(props.ticket).length !== 0 &&
                        <div className={className + '__inner__rating flex-row-flex-start-1rem-gap width-wfa'}>
                            <div className={className + '__inner__rating__title semi-bold-text'}>
                                {props?.field?.title}
                            </div>
                            <div className={className + '__inner__rating__value'}>
                                {
                                    ratingType === 'select' &&
                                        !!fieldEntryOptions?.find((option) => Number(fieldEntryValue) === option.id) &&
                                            (
                                                fieldEntryOptions?.find((option) => Number(fieldEntryValue) === option.id).iconType === 'emoji' ?
                                                    <Emoji
                                                        unified={fieldEntryOptions?.find((option) => Number(fieldEntryValue) === option.id).iconValue.unified}
                                                        size={25}/>
                                                :
                                                    <Chip
                                                        label={fieldEntryOptions?.find((option) => Number(fieldEntryValue) === option.id).title}
                                                        variant='outlined'
                                                        color='primary'
                                                        size='medium'
                                                        avatar={<div className={className + '__top__left__status__indicator small-indicator-box'}
                                                                style={{background: fieldEntryOptions?.find((option) => Number(fieldEntryValue) === option.id).color}}/>}
                                                        />
                                            )
                                }
                                {
                                    ratingType === 'range' &&
                                        <div className={className + '__inner__field__input__range flex-row-center-1rem-gap'}>
                                            <div className={className + '__inner__field__input__range__initial flex-row-center-1rem-gap'}>
                                                {ratingInitialLabel}
                                            </div>
                                            <FormControl className={className + '__inner__field__input__range__list flex-column-center-2vh-gap'}>
                                                <RadioGroup
                                                    value={fieldEntryValue}
                                                    disabled={true}
                                                    row>
                                                    {
                                                        fieldEntryOptions.map((option) =>
                                                            <FormControlLabel labelPlacement='top'
                                                                control={<Radio checked={Number(fieldEntryValue) === Number(option.value)}/>} label={option.value} />
                                                        )
                                                    }
                                                </RadioGroup>
                                            </FormControl>
                                            <div className={className + '__inner__field__input__range__final flex-row-center-1rem-gap'}>
                                                {ratingFinalLabel}
                                            </div>
                                        </div>
                                }
                                {
                                    ratingType === 'scale' &&
                                        <div className={className + '__inner__field__input__range flex-row-center-1rem-gap'}>
                                            {
                                                ratingScaleIcon === 'star' &&
                                                    <Rating
                                                        value={fieldEntryValue}
                                                        max={Number(ratingRange)}
                                                        size='medium'
                                                        disabled={true}/>
                                            }
                                            {
                                                ratingScaleIcon === 'heart' &&
                                                    <HeartStyledRating
                                                        value={fieldEntryValue}
                                                        getLabelText={(value) => `${value} Heart${value !== 1 ? 's' : ''}`}
                                                        max={Number(ratingRange)}
                                                        disabled={true}
                                                        icon={<FavoriteIcon fontSize='inherit' />}
                                                        size='medium'
                                                        emptyIcon={<FavoriteBorderIcon fontSize='inherit' />}/>
                                            }
                                            {
                                                ratingScaleIcon === 'circle' &&
                                                    <CircleStyledRating
                                                        value={fieldEntryValue}
                                                        getLabelText={(value) => `${value} Heart${value !== 1 ? 's' : ''}`}
                                                        max={Number(ratingRange)}
                                                        disabled={true}
                                                        icon={<LensIcon fontSize='inherit' />}
                                                        size='medium'
                                                        emptyIcon={<RadioButtonUncheckedIcon fontSize='inherit' />}/>
                                            }
                                            <div className={className + '__inner__field__input__range__t1 semi-bold-text'}>
                                                {fieldEntryValue}
                                                ⭐
                                            </div>
                                        </div>
                                }
                            </div>
                        </div>
                }
                {
                    props?.field?.type === 'duration' && !!props.ticket && Object.keys(props.ticket).length !== 0 &&
                        <div className={className + '__inner__duration flex-row-flex-start-1rem-gap width-wfa'}>
                            <div className={className + '__inner__duration__title semi-bold-text'}>
                                {props?.field?.title}
                            </div>
                            {
                                !!fieldEntryValue &&
                                    <div className={className + '__inner__number__value'}>
                                        {JSON.parse(fieldEntryValue).days} Days: {JSON.parse(fieldEntryValue).hours} Hours: {JSON.parse(fieldEntryValue).minutes} Minutes: {JSON.parse(fieldEntryValue).seconds} Seconds
                                    </div>
                            }
                        </div>
                }
            </div>
        </div>
    );
}
